import { ReactNode } from 'react';
import RemoveFilterImg from './RemoveFilterImg';

const RemoveFilterBtn = ({
  children,
  index,
  text,
  onClick,
  errorMsg,
  warningMsg,
}: {
  children?: ReactNode;
  index: number;
  text?: string;
  onClick: () => void;
  errorMsg?: boolean;
  warningMsg?: boolean;
}): JSX.Element => {
  return (
    <button
      type="button"
      key={index}
      className="self-center filter-btn focus:outline-none font-ic cursor-pointer"
      title={'Ta bort filter: ' + text}
      tabIndex={0}
      onClick={onClick}
    >
      <span
        className={`flex rounded-full py-1 px-3 md:py-2 ${
          errorMsg
            ? 'bg-red100 hover:shadow-bs40 text-blue1000'
            : warningMsg
            ? 'bg-yellow700 hover:shadow-bs40 text-white'
            : 'bg-blue700 hover:bg-blue900 text-white'
        }`}
      >
        {children ? <>{children}</> : <>{text}</>}
        <RemoveFilterImg error={errorMsg} onClick={onClick} />
      </span>
    </button>
  );
};
export default RemoveFilterBtn;
